import React from "react";
import AdminConsultations from "./AdminConsultations";

/** Admin consultations — unified server-driven table (see AdminConsultations). */
const ConsultationsPage = () => {
  return <AdminConsultations />;
};

export default ConsultationsPage;
